import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { supabase } from '@/lib/supabase';
import { sessionRole } from '@/lib/sessionRole';
import { AppShell } from '@/components/layout/AppShell';

// Admin shell — gated by role + (Sprint 10) MFA aal2 claim.

export const Route = createFileRoute('/admin')({
  beforeLoad: async () => {
    // Server-validated session — getUser() round-trips to Supabase; getSession()
    // would only read the locally-cached JWT, which a tampered localStorage
    // entry could spoof. Admin paths must verify the token server-side.
    const { data, error } = await supabase.auth.getUser();
    if (error || !data.user) throw redirect({ to: '/login' });
    // getUser() validated the session server-side above; read the role from
    // that session's token claim (set by custom_access_token_hook from
    // auth_user_roles) rather than raw_app_meta_data, which may be unset.
    const { data: sessionData } = await supabase.auth.getSession();
    const role =
      sessionRole(sessionData.session) ?? (data.user.app_metadata.role as string | undefined);
    if (role !== 'admin') throw redirect({ to: '/' });
  },
  component: AdminLayout,
});

function AdminLayout() {
  return (
    <AppShell
      role="admin"
      nav={[
        { to: '/admin', label: 'Overview' },
        { to: '/admin/families', label: 'Families' },
        { to: '/admin/dancers', label: 'Dancers' },
        { to: '/admin/classes', label: 'Classes' },
        { to: '/admin/programs', label: 'Programs' },
        { to: '/admin/assessments', label: 'Assessments' },
        { to: '/admin/leads', label: 'Leads' },
        { to: '/admin/reports', label: 'Reports' },
        { to: '/admin/messages', label: 'Messages' },
        { to: '/admin/broadcasts', label: 'Broadcasts' },
        { to: '/admin/productions', label: 'Productions' },
        { to: '/admin/recital-packages', label: 'Recital Packages' },
        { to: '/admin/competitions', label: 'Competitions' },
        { to: '/admin/billing', label: 'Billing' },
        { to: '/admin/cost', label: 'Cost' },
        { to: '/admin/storage', label: 'Video' },
      ]}
    >
      <Outlet />
    </AppShell>
  );
}
